"use strict";

var _jsxRuntime = require("react/jsx-runtime");
module.exports = ({
  title,
  titleId,
  size,
  color,
  ...props
}) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
  ...props,
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  height: size,
  width: size,
  fill: color,
  role: title ? 'img' : undefined,
  "aria-hidden": !title,
  "aria-labelledby": titleId,
  children: [title ? /*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
    id: titleId,
    children: title
  }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fillRule: "evenodd",
    d: "M8.906 17C6.896 13.971 4.5 9.866 4.5 7.5 4.5 3.364 7.864 0 12 0s7.5 3.364 7.5 7.5c0 2.366-2.396 6.471-4.407 9.5H19c.167 0 .323.084.416.223l4 6A.499.499 0 0 1 23 24H1a.5.5 0 0 1-.416-.778l4-6A.503.503 0 0 1 5 17h3.906Zm.676 1H5.268l-3.333 5h20.13l-3.332-5h-4.316a71.196 71.196 0 0 1-2.021 2.804.497.497 0 0 1-.792 0A71.285 71.285 0 0 1 9.582 18ZM12 11c-1.93 0-3.5-1.57-3.5-3.5S10.07 4 12 4s3.5 1.57 3.5 3.5S13.93 11 12 11Zm0-6a2.502 2.502 0 0 0-2.5 2.5c0 1.379 1.12 2.5 2.5 2.5 1.379 0 2.5-1.121 2.5-2.5S13.379 5 12 5Zm0-4a6.508 6.508 0 0 0-6.5 6.5c0 3.136 5.032 10.178 6.5 12.165 1.468-1.987 6.5-9.029 6.5-12.165C18.5 3.916 15.584 1 12 1Z",
    clipRule: "evenodd"
  })]
});